// extracted by mini-css-extract-plugin
export default {"container":"language_select_container__X8hFN","option_container":"language_select_option_container__VcCpk"};